var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21826 0.909252C9.23816 0.909252 9.25806 0.909252 9.27796 0.909252C11.4836 0.909252 13.5638 1.80085 15.142 3.42185C16.7401 5.06375 17.6283 7.25295 17.6442 9.58594C17.6785 14.4057 13.9514 18.3547 9.33567 18.3885C7.11414 18.4094 5.00504 17.5143 3.4124 15.8774C1.81528 14.236 0.92617 12.0458 0.909751 9.71032C0.876913 4.8916 4.60452 0.943582 9.21826 0.909252ZM9.27249 19.2985C9.29588 19.2985 9.31976 19.2985 9.34314 19.298C14.4594 19.2607 18.5915 14.9012 18.5537 9.57947C18.5373 7.01015 17.5566 4.59855 15.7943 2.78748C14.027 0.971442 11.6851 -0.0176726 9.21129 0.000239068C4.09653 0.0375549 -0.0360832 4.39605 0.000237591 9.71679C0.0181492 12.2881 0.998812 14.7012 2.76062 16.5123C4.51098 18.3109 6.82109 19.2985 9.27249 19.2985Z",
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4609 9.51363L5.69567 8.39547L7.9324 12.8691L10.7285 4.48117L14.0836 4.48109L9.73976 16.1177L6.81608 16.1177L3.4609 9.51363Z",
    stroke: "#2E7161",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.4b9d130315a7d2a2bd35e7635675e30a.svg";
export { ForwardRef as ReactComponent };